module.exports = __webpack_public_path__ + "images/rich_heading/brand/icon_176e9c298cb8bd77bf34038e3ccd89d5.png";